<template>
  <div>
    <app-cells><h1 class="title">List of rentals</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'RentalsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'rentals-active', label: 'Active' },
        { name: 'rentals-completed', label: 'Completed' },
      ]
    }
  },
}
</script>
